import { render, staticRenderFns } from "./MyShopForm.vue?vue&type=template&id=2e23a9dc&scoped=true"
import script from "./MyShopForm.vue?vue&type=script&lang=js"
export * from "./MyShopForm.vue?vue&type=script&lang=js"
import style0 from "./MyShopForm.vue?vue&type=style&index=0&id=2e23a9dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e23a9dc",
  null
  
)

export default component.exports